import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

function Navbar() {
  const { currentUser, logout, loading } = useAuth();

  return (
    <nav className="w-full border-b border-gray-200 bg-white py-2 ">
      <div className="mx-auto max-w-7xl ">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img
                className="h-14 w-auto"
                style={{
                  mixBlendMode: "multiply",
                }}
                src="/logo.webp"
                loading="eager"
                alt="Painworth free verdicts and settlements search"
              />
            </Link>
          </div>

          <div className="flex items-center gap-6">
            {currentUser ? (
              <div className="flex items-center gap-6">
                <span className="text-gray-600 text-sm font-medium">
                  {currentUser.email}
                </span>

                <button
                  onClick={logout}
                  className="text-gray-600 hover:text-gray-900 text-sm font-medium"
                >
                  Logout
                </button>
              </div>
            ) : !loading ? (
              <Link
                to="/access-account"
                className="rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 border border-gray-300"
              >
                Login
              </Link>
            ) : null}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
